import { Box, Typography } from '@mui/material'
import FilterControl from 'Components/Filter/FilterControl'
import { TagsSlot } from 'Components/Filter/slots'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

export const FiltersContainer = ({ handleClose, type }) => (
  <Box sx={{ maxHeight: '90%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box
      sx={(theme) => ({
        width: 60,
        height: 6,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 3,
        position: 'absolute',
        top: 8,
        left: 'calc(50% - 15px)',
      })}
    />
    <Box
      display="flex"
      my={2}
      alignItems="center"
      justifyContent="space-between"
      width="300px"
    >
      <Typography>Filters</Typography>
      <FAIcon
        iconFontSize={24}
        color="#9298AA"
        iconClassName={FA_ICONS.CLOSE}
        onClick={handleClose}
      />
    </Box>
    <Box>
      <TagsSlot />
      <FilterControl type={type} />
    </Box>
  </Box>
)
